export var getComponentTopCoordinates = function getComponentTopCoordinates(menuItems) {
  var coordinates = menuItems.map(function (_ref) {
    var text = _ref.text,
        link = _ref.link;
    var currentItem = document.querySelector(link);

    if (currentItem !== null) {
      return {
        top: Math.abs(currentItem.getBoundingClientRect().top),
        text: text
      };
    }

    return {
      top: 0,
      text: text
    };
  });
  return coordinates;
};